export const UNKNOWN_LOCATION = "UNKNOWN_LOCATION"
const FBA_CA = "FBA_CA"
const FBA_UK = "FBA_UK"
const FBA_US = "FBA_US"
const KERRY_LOGISTICS = "KERRY_LOGISTICS"
const MAINFREIGHT_LOGISTICS = "MAINFREIGHT_LOGISTICS"
const NINE_YARDS_LOGISTICS = "NINE_YARDS_LOGISTICS"
const EGO_CASES_VIA_SHOPIFY_COLLECTIVE = "EGO_CASES_VIA_SHOPIFY_COLLECTIVE"

const warehouseIdMap = {
  [EGO_CASES_VIA_SHOPIFY_COLLECTIVE]: "gid://shopify/Location/63702532184", // Special Ops
  [FBA_CA]: "gid://shopify/Location/61837508696", // Canada
  [FBA_UK]: "gid://shopify/Location/61837803608", // UK 1st
  [FBA_US]: "gid://shopify/Location/65875181656", // US
  [KERRY_LOGISTICS]: "gid://shopify/Location/37217075288", // International and UK 3rd
  [MAINFREIGHT_LOGISTICS]: "gid://shopify/Location/10890703", // Domestic
  [NINE_YARDS_LOGISTICS]: "gid://shopify/Location/37217108056", // UK 2nd
}

export const DEFAULT_DOMESTIC_SHIPPING_MESSAGE = "Orders over $49 ship free"
export const DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE =
  "Orders over $39 USD ship free"
export const DEFAULT_DOMESTIC_SPECIAL_OPS_SHIPPING_MESSAGE =
  "Special Ops Cases Ship for $6"
export const DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE =
  ""
export const DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_UNAVAILABLE =
  "Not available outside of the US"

export type ShippingRule = {
  location: string
  shippingMessage: string
}

export const shippingRulesByCountry: Record<string, ShippingRule[]> = {
  AE: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  AR: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  AU: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  BR: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  CA: [
    {
      location: warehouseIdMap[FBA_CA],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  CL: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  DE: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  ES: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  FR: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  GB: [
    {
      location: warehouseIdMap[FBA_UK],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
    {
      location: warehouseIdMap[NINE_YARDS_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  HK: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  ID: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  IN: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  IT: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  JP: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  MX: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  MY: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  NL: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  NZ: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  PH: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  PL: [
    {
      location: warehouseIdMap[NINE_YARDS_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  SG: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  TH: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  TW: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
  UNKNOWN_LOCATION: [
    {
      location: warehouseIdMap[MAINFREIGHT_LOGISTICS],
      shippingMessage: DEFAULT_DOMESTIC_SHIPPING_MESSAGE,
    },
  ],
  US: [
    {
      location: warehouseIdMap[MAINFREIGHT_LOGISTICS],
      shippingMessage: DEFAULT_DOMESTIC_SHIPPING_MESSAGE,
    },
    {
      location: warehouseIdMap[FBA_US],
      shippingMessage: DEFAULT_DOMESTIC_SHIPPING_MESSAGE,
    },
  ],
  VN: [
    {
      location: warehouseIdMap[KERRY_LOGISTICS],
      shippingMessage: DEFAULT_INTERNATIONAL_SHIPPING_MESSAGE,
    },
  ],
}

export const specialOpsShippingRulesByCountry: Record<string, ShippingRule[]> =
  {
    AE: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    AR: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    AU: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    BR: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    CA: [
      {
        location: warehouseIdMap[FBA_CA],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    CL: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    DE: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    ES: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    FR: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    GB: [
      {
        location: warehouseIdMap[FBA_UK],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
      {
        location: warehouseIdMap[NINE_YARDS_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    HK: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    ID: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    IN: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    IT: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    JP: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    MX: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    MY: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    NL: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    NZ: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    PH: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    SG: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    TH: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    TW: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    UNKNOWN_LOCATION: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
    US: [
      {
        location: warehouseIdMap[EGO_CASES_VIA_SHOPIFY_COLLECTIVE],
        shippingMessage: DEFAULT_DOMESTIC_SPECIAL_OPS_SHIPPING_MESSAGE,
      },
    ],
    VN: [
      {
        location: warehouseIdMap[KERRY_LOGISTICS],
        shippingMessage:
          DEFAULT_INTERNATIONAL_SPECIAL_OPS_SHIPPING_MESSAGE_WHEN_AVAILABLE,
      },
    ],
  }

export default shippingRulesByCountry
